import React, { createContext, useContext, useState, useEffect } from 'react'

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {

    const [searchText, setSearchText] = useState(() => {
        const savedState1 = localStorage.getItem('searchText');
        if (savedState1 !== "undefined" && savedState1 !== null) {
            return JSON.parse(savedState1)
        } else {
            return ""
        }
    });

    const [startSearch, setStartSearch] = useState(() => {
        const savedState2 = localStorage.getItem('startSearch');
        if (savedState2 !== "undefined" && savedState2 !== null) {
            return JSON.parse(savedState2)
        } else {
            return false
        }
    });

    const [isClearOn, setIsClearOn] = useState(() => {
        const savedState3 = localStorage.getItem('isClearOn');
        if (savedState3 !== "undefined" && savedState3 !== null) {
            return JSON.parse(savedState3)
        } else {
            return false
        }
    });


    const [IsAdvanced, setIsAdvanced] = useState(() => {
        const savedState3 = localStorage.getItem('IsAdvaced');
        if (savedState3 !== "undefined" && savedState3 !== null) {
            return JSON.parse(savedState3)
        } else {
            return false
        }
    });


    const [JupDurselectedValue, setJupDurselectedValue] = useState(() => {
        const savedStateJup = localStorage.getItem('JupDurselectedValue');
        if (savedStateJup !== "undefined" && savedStateJup !== null) {
            return JSON.parse(savedStateJup)
        } else {
            return false
        }
    });
    const [JupSalselectedValue, setJupSalselectedValue] = useState(() => {
        const savedStateJup = localStorage.getItem('JupSalselectedValue');
        if (savedStateJup !== "undefined" && savedStateJup !== null) {
            return JSON.parse(savedStateJup)
        } else {
            return false
        }
    });

    const [IndustryselectedValue, setIndustryselectedValue] = useState(() => {
        const savedStateIndus = localStorage.getItem('IndustryselectedValue');
        if (savedStateIndus !== "undefined" && savedStateIndus !== null) {
            return JSON.parse(savedStateIndus)
        } else {
            return false
        }
    });

    const [searchClientNameText, setClientNameText] = useState(() => {
        const savedClient = localStorage.getItem('searchClientNameText');
        if (savedClient !== "undefined" && savedClient !== null) {
            return JSON.parse(savedClient)
        } else {
            return ""
        }
    });

    const [searchOppLeaderText, setOppLeaderText] = useState(() => {
        const savedOppLeader = localStorage.getItem('searchOppLeaderText');
        if (savedOppLeader !== "undefined" && savedOppLeader !== null) {
            return JSON.parse(savedOppLeader)
        } else {
            return ""
        }
    });


    const [searchOppSpltLeaderText, setOppSplitLeaderText] = useState(() => {
        const savedOppsplitLeader = localStorage.getItem('searchOppSpltLeaderText');
        if (savedOppsplitLeader !== "undefined" && savedOppsplitLeader !== null) {
            return JSON.parse(savedOppsplitLeader)
        } else {
            return ""
        }
    });
    const [topRowSelectedValue, settopRowSelectedValue] = useState(() => {
        const savedTopRows = localStorage.getItem('topRowSelectedValue');
        if (savedTopRows !== "undefined" && savedTopRows !== null) {
            return JSON.parse(savedTopRows)
        } else {
            return ""
        }
    });


    useEffect(() => {
        localStorage.setItem('searchText', JSON.stringify(searchText));
    }, [searchText]);

    useEffect(() => {
        localStorage.setItem('startSearch', JSON.stringify(startSearch));
    }, [startSearch]);

    useEffect(() => {
        localStorage.setItem('isClearOn', JSON.stringify(isClearOn));
    }, [isClearOn]);

    useEffect(() => {
        localStorage.setItem('IsAdvaced', JSON.stringify(IsAdvanced));
    }, [IsAdvanced]);

    useEffect(() => {
        localStorage.setItem('JupDurselectedValue', JSON.stringify(JupDurselectedValue));
    }, [JupDurselectedValue]);
    useEffect(() => {
        localStorage.setItem('JupSalselectedValue', JSON.stringify(JupSalselectedValue));
    }, [JupSalselectedValue]);

    useEffect(() => {
        localStorage.setItem('IndustryselectedValue', JSON.stringify(IndustryselectedValue));
    }, [IndustryselectedValue]);

    useEffect(() => {
        localStorage.setItem('searchClientNameText', JSON.stringify(searchClientNameText));
    }, [searchClientNameText]);


    useEffect(() => {
        localStorage.setItem('searchOppSpltLeaderText', JSON.stringify(searchOppSpltLeaderText));
    }, [searchOppSpltLeaderText]);

    useEffect(() => {
        localStorage.setItem('searchOppLeaderText', JSON.stringify(searchOppLeaderText));
    }, [searchOppLeaderText]);

    useEffect(() => {
        localStorage.setItem('topRowSelectedValue', JSON.stringify(topRowSelectedValue));
    }, [topRowSelectedValue]);


    return (
        <StoreContext.Provider value={{
            searchText, setSearchText, startSearch, setStartSearch, isClearOn, setIsClearOn, IsAdvanced,
            setIsAdvanced, JupDurselectedValue, setJupDurselectedValue, setJupSalselectedValue, JupSalselectedValue,
            setIndustryselectedValue, IndustryselectedValue, searchClientNameText, setClientNameText
            , searchOppLeaderText, setOppLeaderText,
            searchOppSpltLeaderText, setOppSplitLeaderText, topRowSelectedValue, settopRowSelectedValue
        }}>
            {children}
        </StoreContext.Provider>
    )
}

export const useStore = () => {
    return useContext(StoreContext);
};